import {keyBy} from 'lodash';

import {CustomViewModel} from '../../../models/api/customViewModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DelegationsActionsEnum} from '../delegations/delegationsActions';
import {CustomViewsActionsEnum} from './customViewsActions';

export function customViewsReducer(
  state: ResourceMap<CustomViewModel>,
  action: AppAction,
): ResourceMap<CustomViewModel> {
  switch (action.type) {
    case CustomViewsActionsEnum.SET_CUSTOM_VIEWS:
      return keyBy(action.payload, (c) => c.id);

    case DelegationsActionsEnum.DELEGATION_UPDATED:
      return {
        ...state,
        ...keyBy(action.payload.customViews, (cv) => cv.id),
      };

    default:
      return state;
  }
}
